import type { Routes } from "shared/react";
import { Router } from "shared/react";
import { CREATOR_ROUTES } from "../create/CreatorRouter.js";
import { AssignedChallengesPage } from "./AssignedChallengesPage.js";
import { GroupAboutPage } from "./GroupAboutPage.js";
import { LoadGroupContext } from "./GroupContext.js";
import { GroupLeaderboardsPage } from "./GroupLeaderboardsPage.js";
import { GroupSettingsPage } from "./GroupSettingsPage.js";
import { InvitePage } from "./InvitePage.js";
import { MembersPage } from "./MembersPage.js";
import { MessagesPage } from "./MessagesPage.js";

export function GroupRouter({ gid, slug = "" }: { gid: string; slug?: string | undefined }): React.ReactElement {
	return (
		<LoadGroupContext gid={gid}>
			<Router path={`/${slug}`} routes={GROUP_ROUTES} />
		</LoadGroupContext>
	);
}

const GROUP_ROUTES: Routes = {
	"/about": GroupAboutPage,
	"/messages": MessagesPage,
	"/settings": GroupSettingsPage,
	"/invite": InvitePage,
	"/assigned": AssignedChallengesPage,
	"/leaderboards": GroupLeaderboardsPage,
	"/members": "/members/approved",
	"/members/{filter}": MembersPage,
	"/": "/messages",
	...CREATOR_ROUTES,
};
